<template>
  <v-row fill-height align="center" justify="center" no-gutters>
    <v-col cols="6">
      <v-row no-gutters>
        <v-col cols="11">
          <v-text-field outlined :placeholder="$i18n.t('placeHolder')" rounded height="55px" class="text-h5"
            hide-details :append-icon="expand ? '' : 'mdi-magnify'" @click:append-outer="expand = false"
            @click="expand = true" :value="searchKeyword" v-model="searchKeyword" clearable>
          </v-text-field>
        </v-col>
        <v-col cols="1">
          <template v-if="!getKioskProfile.data().physicalKeyboard">
            <v-icon size="45" class="ml-2 mt-1" v-if="!expand" @click="expand = !expand">mdi-keyboard-outline</v-icon>
            <v-icon size="45" class="ml-2 mt-1" v-else @click="
              expand = !expand;
            clearSearch();
            searchId = '';
            ">mdi-keyboard-off-outline</v-icon>
          </template>
        </v-col>
      </v-row>
      <div v-if="expand">
        <v-expand-transition>
          <SimpleKeyboard @onChange="onChange" @onKeyPress="onKeyPress" :input="searchKeyword" class="keyboard">
          </SimpleKeyboard>
        </v-expand-transition>
      </div>
    </v-col>
    <v-col cols="12" align="center" @click="expand = false" class="mt-4">
      <v-card class="pa-4 containerBorder" width="95%">
        <v-data-table hide-default-footer :items-per-page="-1" :height="viewBoxHeight" :headers="header" :items="list"
          :loading="loading" loading-text="Fetching latest data. Please wait..." fixed-header>
          <template v-slot:item.partyName="{ item }">
            <div class="my-7" v-if="item.partyName === ''"> - </div>
            <div class="my-7" v-else>
              {{ item.partyName }}
            </div>
          </template>
          <!-- <template v-slot:item.judgeName="{ item }">
            <span v-if="item.judgeName === undefined"> - </span>
            <span v-else>Judge {{ item.judgeName }}</span>
          </template> -->
          <template v-slot:item.location="{ item }">
            <v-btn @click="handleCourtLocation(item.location)" width="100%" elevation="0" color="primary" class="my-2">
              <v-icon left>mdi-gesture-tap</v-icon>
              {{ item.location }}
            </v-btn>
          </template>
          <template v-slot:item.hearingTime="{ item }">
            <span>{{ item.hearingTime | dateAndTime }}</span>
          </template>
        </v-data-table>
        <v-card-title class="mt-3 pa-0 d-flex align-center justify-center">Can't find your hearing?
          <v-btn class="mx-5 mt-2" color="primary" @click="openHearingSearchPortal()">Hearing Portal</v-btn>
        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SimpleKeyboard from "@/components/SimpleKeyboard";
import moment from "moment";
import { mapGetters } from "vuex/dist/vuex.common.js";
export default {
  name: "todayshearing",
  data() {
    return {
      searchKeyword: null,
      viewBoxHeight: 600,
      expand: false,
      loading: true,
      header: [
        {
          text: "Parties Name",
          align: "start",
          value: "name",
          width: "750",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        },
        {
          text: "Court Room Location",
          align: "center",
          value: "location",
          width: "300",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        },
        {
          text: "Court Room Floor",
          align: "center",
          value: "floor",
          width: "300",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        },
        {
          text: "Date/Time",
          align: "center",
          value: "time",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['getHearingList', "getKioskProfile", "getSessionId"]),
    list() {
      if (this.searchKeyword === "" || this.searchKeyword === null) {
        return this.getHearingList
      } else {
        let tempHearingList = []
        this.getHearingList.forEach(hearingObj => {
          if (hearingObj.name.toLowerCase().includes(this.searchKeyword.toLowerCase())) {
            tempHearingList.push(hearingObj)
          }
        })
        return tempHearingList;
      }
    }
  },
  components: {
    SimpleKeyboard
  },
  watch: {
    expand(n, o) {
      if (n) {
        this.viewBoxHeight = 370
      } else {
        this.viewBoxHeight = 600;
      }
    }
  },
  methods: {
    onChange(input) {
      this.searchKeyword = input;
    },
    onKeyPress(button) {
      if (button === "{bksp}")
        this.searchKeyword = this.searchKeyword.slice(0, -1);
    },
    onInputChange(input) {
      this.searchKeyword = input.target.value;
    },
    handleCourtLocation(location) {
      var mapLocation = this.$i18n.t("maps").filter(map => map.mapName === location)[0]
      console.log('Hearing Room location: ', mapLocation)
      var floorInfo = this.$i18n.t("floors").filter(floor => floor.floorNumber.toString() === mapLocation.mapFloor.toString())
      console.log('Floors: ', floorInfo)
      this.$store.dispatch('openImageViewer', {
        name: mapLocation.mapName,
        url: mapLocation.mapImage,
        floor: this.$i18n.t("floors").filter(floor => floor.floorNumber === mapLocation.mapFloor)[0].floorName
      })
      this.$store.dispatch('addSessionDatatoStrapi', {
        applicationId: this.getKioskProfile.data().applicationId,
        applicationSessionId: this.getSessionId,
        timeStamp: moment().toISOString(),
        actionType: 'Touch',
        sessionPayload: {
          module: "Maps",
          action: "View Map",
          response: mapLocation.mapName,
        }
      })
      this.$store.dispatch('addInteractionToPostgres', {
        actionType: 'Interaction',
        actionPayload:
          { module: 'Maps', navigateFrom: "Today's Hearing", navigateTo: "Today's Hearing", interactionType: 'Touch', elementContent: mapLocation.mapName }
      })
    },
    openHearingSearchPortal() {
      window.open("https://www.courts.mo.gov/cnet/nameSearch.do?newSearch=Y")
    }
  },
  mounted() {
    this.loading = false
    console.log('Hearing List: ', this.getHearingList.length)
    // setTimeout(() => {
    //   this.$store.dispatch("fetchHearingInfo").then(response => {
    //     if (response) {
    //       this.loading = false
    //     }
    //   })
    // }, 1500)

  },
  filters: {
    formatStringDate(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("LL");
    },
    formatStringTime(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("LT");
    },
  },
};
</script>

<style></style>

<i18n>
{
  "en": {
      "searchcaseno": "Search by case number",
      "searchcasename": "Search by name",
      "firstnamelabel": "First Name",
      "middlenamelabel": "Middle Name",
      "lastnamelabel": "Last Name",
      "casenolabel": "Case Number",
      "casenobutton": "Case Number Search",
      "searchnamebutton": "Search by Name",
      "casenoplaceholder": "Tap to enter case number. E.g. D-xx-xxx-xxxx-xxxxx",
      "placeHolder": "Tap to search by name"
    },
  "es":{
      "searchcaseno": "Buscar por número de caso",
      "searchcasename": "Buscar por nombre",
      "firstnamelabel": "Primer nombre",
      "middlenamelabel": "Segundo nombre",
      "lastnamelabel": "Apellido",
      "casenolabel": "Número de caso",
      "casenobutton": "Número de caso",
      "searchnamebutton": "Buscar por nombre",
      "casenoplaceholder": "Toque para ingresar el número de caso. P.ej. D-xx-xxx-xxxx-xxxxx"
    }
}
</i18n>
